import { OptionProperty } from '@/ui-kit/components/form/controls/components/select/enums';
import { StyleSizeType } from '@/ui-kit/styles/enums';
import { CAROUSEL_SPACE_MAP } from '@/ui-kit/components/carousel/constants';
import { UserRole } from '@/constants/user';

export const PHONE_NUMBER_REGEXP = /(\d{1,3})(\d{1,3})(\d{1,4})/g;
export const BUYER_TYPE_OPTIONS = [
  {
    [OptionProperty.Label]: 'I\'m a buyer',
    [OptionProperty.Value]: UserRole.Buyer,
  },
  {
    [OptionProperty.Label]: 'I\'m an Agent representing a buyer',
    [OptionProperty.Value]: UserRole.Realtor,
  },
];

export const BOOK_VIEWING_CAROUSEL_BREAKPOINTS = {
  [StyleSizeType.XSmall]: {
    slidesPerView: 3,
    spaceBetween: CAROUSEL_SPACE_MAP[StyleSizeType.Medium],
  },
  [StyleSizeType.Small]: {
    slidesPerView: 3,
    spaceBetween: CAROUSEL_SPACE_MAP[StyleSizeType.Medium],
  },
  [StyleSizeType.Medium]: {
    slidesPerView: 2,
    spaceBetween: CAROUSEL_SPACE_MAP[StyleSizeType.Medium],
  },
  [StyleSizeType.Large]: {
    slidesPerView: 2,
    spaceBetween: CAROUSEL_SPACE_MAP[StyleSizeType.Medium],
  },
};
